import providers from "../ga/providers";
import sessionStore from "../storageAPIs/sessionStore";
import isPasswordlessFlow from "./isPasswordlessFlow";

const getLoginEvent = (provider) => {
  const someProvider = providers[provider];
  if (isPasswordlessFlow()) return "login-passwordless";
  else return someProvider ? `login-${someProvider}` : "login";
};

export default (config, funcs, user, provider) => (result, cb) => {
  const loginProvider = provider || sessionStore.getSomeLoginFlow();
  const eventParameters = [true, result, getLoginEvent(loginProvider), "almatunnus-login", config.storedSource];
  const sendRegistration = funcs.analytics.sendRegistration;
  const sendAuthenticationEvent = funcs.analytics.sendAuthenticationEvent;
  return config.analyticsWait
    ? () => {
        if (user?.fromSignUp) sendRegistration(true, false, sendAuthenticationEvent(...eventParameters, cb));
        else sendAuthenticationEvent(...eventParameters, cb);
      }
    : () => {
        if (user?.fromSignUp) sendRegistration(true, false);
        sendAuthenticationEvent(...eventParameters);
        cb();
      };
};
